import { analytics } from './firebase';
import { logEvent, setUserId, setUserProperties } from 'firebase/analytics';

/**
 * Service to handle application telemetry and analytics
 */
class TelemetryService {
    constructor() {
        this.analytics = analytics;
    }

    /**
     * Log a custom event
     * @param {string} eventName - Name of the event (e.g., 'expense_created', 'game_viewed')
     * @param {Object} params - Optional parameters for the event
     */
    logEvent(eventName, params = {}) {
        if (this.analytics) {
            try {
                logEvent(this.analytics, eventName, params);

                // Log to console in development for visibility
                if (import.meta.env.DEV) {
                    console.log(`📊 [Telemetry] ${eventName}`, params);
                }
            } catch (error) {
                console.warn('Failed to log telemetry event:', error);
            }
        }
    }

    /**
     * Set the user ID for subsequent events
     * @param {string} userId - Unique identifier for the user
     */
    setUser(userId) {
        if (this.analytics && userId) {
            try {
                setUserId(this.analytics, userId);
                if (import.meta.env.DEV) {
                    console.log(`👤 [Telemetry] User Set: ${userId}`);
                }
            } catch (error) {
                console.warn('Failed to set telemetry user:', error);
            }
        }
    }

    /**
     * Set user properties
     * @param {Object} properties - Key-value pairs of user properties
     */
    setUserProperties(properties) {
        if (this.analytics && properties) {
            try {
                setUserProperties(this.analytics, properties);
            } catch (error) {
                console.warn('Failed to set user properties:', error);
            }
        }
    }
}

export default new TelemetryService();
